module.exports = __webpack_public_path__ + "static/img/Willem-Duursma.79bbf2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Willem-Duursma.jpg
// module id = mnd7
// module chunks = 0